import React from "react";
import {
  AlertDialog, AlertDialogContent, AlertDialogTitle, AlertDialogDescription,
} from "@/components/ui/alert-dialog";

// The one confirm for the app. window.confirm() blocks the tab's event loop —
// a native dialog left open freezes the page behind it — and it can be neither
// styled nor tested. Radix gives focus trapping and Escape for free; Title and
// Description are always rendered, so nothing here trips the a11y warning the
// other modals log.
export default function ConfirmDialog({
  open, onOpenChange, title, description,
  confirmLabel = "Confirmă", cancelLabel = "Anulează",
  destructive = false, busy = false, onConfirm, testId = "confirm-dialog",
}) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent
        data-testid={testId}
        className="max-w-sm gap-0 p-0 bg-surface border-line/10 shadow-xl rounded-none sm:rounded-none"
      >
        <div className="px-4 py-3 border-b border-line/10">
          <AlertDialogTitle className="text-base font-bold tracking-tight">{title}</AlertDialogTitle>
        </div>
        <div className="p-4 space-y-4">
          <AlertDialogDescription className="text-sm text-fg/70">{description}</AlertDialogDescription>
          <div className="flex justify-end gap-2">
            <button type="button" onClick={() => onOpenChange(false)}
              className="btn-ghost text-sm px-3 py-1.5" data-testid={`${testId}-cancel`}>
              {cancelLabel}
            </button>
            <button type="button" onClick={onConfirm} disabled={busy} data-testid={`${testId}-confirm`}
              className={destructive
                ? "text-sm px-3 py-1.5 font-medium bg-red-600 text-white hover:bg-red-500 disabled:opacity-50"
                : "btn-primary text-sm px-3 py-1.5 disabled:opacity-50"}>
              {confirmLabel}
            </button>
          </div>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  );
}
